import { useMemo } from "react";
import { bool, func } from "prop-types";
import { useTranslation } from "react-i18next";
import { AddButtonFull } from "@components";

export const AddBufferButton = ({
  onAdd,
  itemBuffer,
}) => {
  const { t } = useTranslation();
  
  const buttonTitle = useMemo(() => (
    t(`views.editor.dialogs.buffers.create.${itemBuffer ? "item" : "project"}`)
  ), [itemBuffer]);
  
  return (
    <AddButtonFull
      id="createBuffer"
      onClick={onAdd}
      name={buttonTitle}
      className="mt-2 ml-2"
    >
      {buttonTitle}
    </AddButtonFull>
  );
}

AddBufferButton.propTypes = {
  onAdd: func.isRequired,
  itemBuffer: bool,
}